import { Component, HostListener, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { IDisease } from 'src/app/Shared/model/disease.model';
import { HttpStatusCode, ResponseModel } from 'src/app/Shared/model/response.model';
import { ApiDataService } from 'src/app/Shared/services/apidata.service';
import { AppService } from 'src/app/Shared/services/app.service';

@Component({
  selector: 'app-disease-slider',
  templateUrl: './disease-slider.component.html',
  styleUrls: ['./disease-slider.component.scss']
})
export class DiseaseSliderComponent implements OnInit {
  disease: IDisease[] = [];

  mobileview = false;
  slideConfig = {};
  currentLang = 'en';
  public subscriptions$: Subscription[] = [];


  constructor(private apiservice: ApiDataService, private appsetting: AppService,
    public translate: TranslateService,
    public appservice: AppService) {
  }
  ngOnInit(): void {
    this.getDiseaseList();
    this.mobileview = (window.innerWidth < 600);
    this.slideConfig = this.appsetting.getSliderConfig(4, this.mobileview);
    this.subscriptions$.push(
      //------------Subscribe languege change---------------------
      this.appservice.getcurrentLanguage().subscribe((locale) => {
        this.currentLang = locale;
        localStorage.setItem('locale', locale);
      })
    );

    this.currentLang = this.appservice.getSavecurrentLanguage();
  }


  @HostListener('window:resize', ['$event'])
  onResize() {
    this.mobileview = (window.innerWidth < 600);
    this.slideConfig = this.appsetting.getSliderConfig(4, this.mobileview);
  }

  getDiseaseList() {
    const url = `Diseases/GetAllActiveDiseasesList?PageSize=0&PageNumber=0`;
    this.apiservice.getData(url).subscribe
      ((response: ResponseModel<any>) => {
        if (response.status === HttpStatusCode.OK) {
          this.disease = response.data.diseases;
        }
      });
  }

}
